import { fetcher } from '#lib/backendFetcher';
import { validateResponse } from '#lib/validation';

import { walletSchema } from './creditsSchemas';

/**
 * Fetches the credits wallet of the currently logged-in user.
 * @returns {Promise<{data: Object|null, error: string|null}>} The validated wallet object or an error message
 */
export const fetchUserCreditsWallet = async () => {
	try {
		const data = await fetcher('/api/v1/platform/users/me/wallet');
		if (data) validateResponse(walletSchema, data, 'wallet');
		return { data, error: null };
	} catch (err) {
		return { data: null, error: err.message };
	}
};
